export const organisationUserConstants = {
  BASE_PATH: '/v1/organisation_users',
  GET_ORGANISATION_USERS: 'GET_ORGANISATION_USERS',
  UPDATE_ORGANISATION_USER: 'UPDATE_ORGANISATION_USER',
  UPDATE_ORGANISATION_USERS_LOADING: 'UPDATE_ORGANISATION_USERS_LOADING',
};
